import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";
import { useLang } from "../context/LanguageContext";

export default function CtaBand({ title, text, btn }) {
  const { t } = useLang();
  return (
    <section className="relative py-24 lg:py-28 overflow-hidden" data-testid="cta-band">
      <div className="absolute inset-0 bg-gradient-to-r from-cobalt/10 via-sovereign/5 to-transparent" aria-hidden="true" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="glass p-10 lg:p-16 relative overflow-hidden" data-testid="cta-panel">
          <div className="scanlines absolute inset-0 pointer-events-none" aria-hidden="true" />
          <div className="grid lg:grid-cols-[1.5fr_1fr] gap-8 items-center">
            <div>
              <Reveal>
                <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-100 leading-tight">{title}</h2>
              </Reveal>
              {text && (
                <Reveal delay={0.1}>
                  <p className="mt-4 text-slate-400 max-w-xl">{text}</p>
                </Reveal>
              )}
            </div>
            <Reveal delay={0.15} className="lg:text-right">
              <Link
                to="/contact"
                data-testid="cta-band-button"
                className="group inline-flex items-center gap-3 bg-sovereign text-obsidian font-semibold px-8 py-4 text-sm tracking-wide uppercase hover:shadow-[0_0_40px_rgba(0,240,255,0.4)] hover:-translate-y-0.5 transition-all duration-300"
              >
                {btn || t.home.cta.btn}
                <span className="transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true">→</span>
              </Link>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
